import React, { useEffect, useState, useMemo, useContext, useRef } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import { toastError, toastWarn } from "../../../common/Toast";
import { Noimage } from "../../../common/imagePath";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
// import "./Demotable.css";
import moment from "moment";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import CurrencySymbols from "../../../common/Reportcurrencysymbols";

const Demoreport = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, currencySymbolLocation } =
    useContext(AppContext);

  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [brandId, setBrandId] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [searchItemName, setSearchItemName] = useState("");
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesId, setCategoriesId] = useState([]);

  Number(locationid);

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationid}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          if (res.data.ResponseData.length > 0) {
            const modifiedData = res.data.ResponseData.map((item) => ({
              ...item,
              ID: item.ItemId,
              VariationId: item.VariationId,
              Name:
                item.VariationName != "" ? item.VariationName : item.ItemName,
              ImageURL: item.ImageName,
              Quantity:
                item.VariationId != 0
                  ? item.VariationQuantity
                  : item.Itemquantity,
              Categoryfullpath: item.CategoryName,
            }));
            setSuggestions(modifiedData);
            setLoading(false);
          } else {
            toastWarn("No Item Found");
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/salesvelocityreport?&brandid=${brandId}&categoryid=${categoriesId}&locationid=${locationid}&selectedItems=${encodeURIComponent(
          JSON.stringify(selectedItems)
        )}&itemid=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData?.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went Wrong");
        setLoading(false);
        return;
      });
  };

  const handleInputClick = (item) => {
    console.log(item, "checkitemdata");

    const newItem = {
      ItemId: item.ItemId,
      variationId: item.VariationId,
      itemName: item.VariationId > 0 ? item.VariationName : item.ItemName,
    };

    setSelectedItems((prev) => {
      // Optional: avoid duplicates by ItemId + variationId
      const exists = prev.some(
        (i) =>
          i.ItemId === newItem.ItemId && i.variationId === newItem.variationId
      );
      return exists ? prev : [...prev, newItem];
    });
    setSearchItemName("");
  };

  useEffect(() => {
    // Brand Dropdown
    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setBrands(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // categories Dropdown
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setCategories(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      title: "Item",

      headerFilter: "input",
      field: "ItemName",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Variation",

      headerFilter: "input",
      field: "VariationName",
      defaultVisible: true,
    },
    {
      title: "Current Qty",

      headerFilter: "input",
      field: "Quantity",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();

        console.log(value, "valuevalue");

        if (value == "0.00" || value === "") {
          return "0.0";
        }

        return CurrencySymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "1W (Last 7 days)",

      headerFilter: "input",
      field: "AvgQty_1W",
      defaultVisible: true,
    },
    {
      title: "2W (Last 14 days)",

      headerFilter: "input",
      field: "AvgQty_2W",
      defaultVisible: true,
    },
    {
      title: "4W (Last 28 days)",

      headerFilter: "input",
      field: "AvgQty_4W",
      defaultVisible: true,
    },
    {
      title: "8W (Last 56 days)",

      headerFilter: "input",
      field: "AvgQty_8W",
      defaultVisible: true,
    },
    {
      title: "12W (Last 84 days)",
      headerFilter: "input",
      field: "AvgQty_12W",
      defaultVisible: true,
    },
    {
      title: "16W (Last 112 days)",

      headerFilter: "input",
      field: "AvgQty_16W",
      defaultVisible: true,
    },
    {
      title: "Overall Avg",

      headerFilter: "input",
      field: "OverallAvgPerDay",
      defaultVisible: true,
    },
    {
      title: "WMA",

      headerFilter: "input",
      field: "WMA_Avg",
    },
    {
      title: "Days of Stock Left",

      headerFilter: "input",
      field: "Days_Left",
    },
    {
      title: "Reorder Level",

      headerFilter: "input",
      field: "ReorderQty",
    },
    {
      title: "Replenish Level",

      headerFilter: "input",
      field: "ReplenishQty",
    },
    {
      title: "Reorder Needed",

      headerFilter: "input",
      field: "ReorderNeeded",
    },
    {
      title: "Suggested Order Qty",

      headerFilter: "input",
      field: "SuggestedOrderQty",
    },
    {
      title: "Category",

      headerFilter: "input",
      field: "CategoryPath",
    },
    {
      title: "Brand",

      headerFilter: "input",
      field: "Brand",
    },
  ];

  const handleDropdownchange = (selectedOptions) => {
    const items = selectedOptions?.map((opt) => opt.data) || [];
    setSelectedItems(items);
  };

  const selectOptions = selectedItems.map((item) => ({
    value: item.ItemId + "-" + item.variationId,
    label: item.itemName,
    data: item,
  }));

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales Velocity Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-auto">
              <label className="col-form-label col-md-3">Brands</label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={brands}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setBrandId(selected?.map((e) => e.value) || [])
                    }
                    value={brands.filter((b) => brandId.includes(b.value))}
                    className="reports-filter-custom-width custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="col-auto">
              <label className="col-form-label col-md-3">Categories</label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={categories}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setCategoriesId(selected?.map((e) => e.value) || [])
                    }
                    value={categories.filter((b) =>
                      categoriesId.includes(b.value)
                    )}
                    className="reports-filter-custom-width custom-select-search z-5"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between col-auto gap-2">
              <div className="col-sm-6">
                <label className="col-form-label form-label">
                  Serach Items
                </label>
                <input
                  type="search"
                  placeholder="Search..."
                  // className="form-control-sm w-100 mt-1"
                  className="reports-filter-custom-width search-btn form-control form-control-sm w-100"
                  onChange={(e) => {
                    setSearchItemName(e.target.value);
                  }}
                  value={searchItemName}
                  style={{ width: "300px" }}
                />

                {suggestions?.length > 0 ? (
                  <>
                    <div className="dropdown">
                      <ul
                        className="dropdown-menu show dropdown-suggestion"
                        style={{
                          overflow: "auto",
                          width: "120% ",
                          maxWidth: "600px",
                        }}
                      >
                        {suggestions?.map((item) => (
                          <li
                            className="border-bottom"
                            key={item.ID}
                            onClick={(e) => handleInputClick(item)}
                          >
                            <Link
                              key={item.ID}
                              href="#"
                              class="dropdown-item"
                              data-name={item.Name?.toLowerCase()}
                            >
                              <img
                                src={item.ImageURL || Noimage}
                                onError={(e) => {
                                  e.currentTarget.src = Noimage;
                                }}
                                alt={item.Name}
                                className="img-thumbnail rounded-circle mr-4"
                                width="55"
                                height="55"
                                style={{
                                  height: "60px",
                                  objectFit: "contain",
                                }}
                              />
                              <div className="customer-info w-100">
                                <strong
                                  className="word-break-data"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                >
                                  {item.Name}{" "}
                                  {item.Name ? `(${item.Name})` : ""}
                                </strong>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : null}
              </div>
              <div className="col-auto">
                <label className="col-form-label form-label">
                  Selected Items
                </label>
                <Select
                  onChange={(selectedOptions) =>
                    handleDropdownchange(selectedOptions)
                  }
                  options={selectOptions}
                  value={selectOptions}
                  isMulti
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  className="reports-filter-custom-width custom-search-select"
                />
              </div>
              <div className="col-auto align-self-sm-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => {
                    apiCall();
                  }}
                >
                  Run Report
                </button>
              </div>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Sales Velocity Report</p>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div>
                      <CommonTabular
                        Data={responseData}
                        columns={columns}
                        Groupvalue={["ItemName"]}
                        Reportname={"DemoReport"}
                        frozenRowvalue={0}
                        Onrefresh={() => apiCall()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Demoreport;
